import { render } from "./signup-password.vue?vue&type=template&id=fccc8de0&scoped=true"
import script from "./signup-password.vue?vue&type=script&lang=js"
export * from "./signup-password.vue?vue&type=script&lang=js"

import "./signup-password.vue?vue&type=style&index=0&id=fccc8de0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fccc8de0"]])

export default __exports__